module.exports = __webpack_public_path__ + "static/Header_subpage-f73d7bfa9f8c22a0ef12afe160a37557.svg";